import React, { useCallback, useImperativeHandle, useState } from 'react'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import SydModal from '../../../commonDesign/SydModal'
import { useModifyClientKeyDatapointValues } from '../../../../api/groups'
import { useAppContext } from '../../../../redux/slices/appContext'
import { KDP } from '../../../../policies/admin'
import { usePolicy } from '../../../../hooks/usePolicy'
import KDPDialogForm from './KDPDialogForm'

dayjs.extend(utc)

export const KDPDialog = React.forwardRef(function KDPDialog (_, ref) {
  const [open, setOpen] = useState(false)
  const [kdp, setKdp] = useState(null)
  const [format, setFormat] = useState(null)
  const hasAccess = usePolicy(KDP.editKDP)
  const { mutateAsync: modifyKdp, isLoading: isSaving } = useModifyClientKeyDatapointValues()
  const { clientId } = useAppContext()
  const close = useCallback(() => {
    if (hasAccess) {
      setOpen(false)
    }
  }, [setOpen, hasAccess])
  useImperativeHandle(ref, () => ({
    open: (kdp, format) => {
      if (!kdp) {
        return
      }
      setOpen(true)
      setKdp(kdp)
      setFormat(format)
    },
    close: () => setOpen(false)
  }), [setOpen, setKdp, setFormat])

  const onError = useCallback((errors) => {
    console.warn('errors', errors)
  }, [])
  const onSave = useCallback(async (data) => {
    if (!hasAccess) {
      return
    }
    const newDatapoint = {
      clientId,
      datapoints: [
        {
          datapointId: kdp.datapointId,
          value: data[kdp.codeName]
        }
      ]
    }
    const result = await modifyKdp(newDatapoint)
    if (result?.message === 'Ok') {
      close()
    } else {
      console.error('error modifying KDP', result)
    }
  }, [modifyKdp, kdp, clientId, hasAccess, close])
  return (
    <SydModal
      title='Edit Key Datapoint'
      open={open}
      onClose={close}
      size='medium'
      position='top'
      disablePortal={false}
    >
      {kdp ? (
        <KDPDialogForm kdp={kdp} format={format} close={close} onSave={onSave} onError={onError} isSaving={isSaving} />
      ) : (
        <div>No KDP selected</div>
      )}
    </SydModal>
  )
})

export default KDPDialog
